import axios from "axios";
const client = axios.create({ withCredentials: true });

const DRUPAL_API_ROUTE = {
  CRSF_TOKEN: {
    method: "GET",
    path: "/session/token?_format=json",
  },
  LOGIN: {
    method: "POST",
    path: "/user/login?_format=json",
  },
  LOGOUT: {
    method: "GET",
    path: "/user/logout?_format=json&token=:logout_token",
  },
  REGISTER: {
    method: "POST",
    path: "/user/registerpass?_format=json",
  },
  FORGOT_PASSWORD: {
    method: "POST",
    path: "/user/lost-password?_format=json",
  },
  FORGOT_PASSWORD_RESET: {
    method: "POST",
    path: "/user/lost-password-reset?_format=json",
  },
  USER: {
    method: "GET",
    path: "/api/user",
  },
  USER_UPDATE: {
    method: "PATCH",
    path: "/user/:uid?_format=json",
  },
  CONTACTS: {
    method: "GET",
    path: "/api/contacts",
  },
  NEW_BLACKLIST_MONITOR: {
    method: "POST",
    path: "/api/monitors/blacklists",
  },
  BLACKLIST_MONITORS: {
    method: "GET",
    path: "/api/monitors/blacklists",
  },
  UPDATE_BLACKLIST_MONITOR: {
    method: "PATCH",
    path: "/api/monitors/blacklists/:monitor_id",
  },
  DELETE_BLACKLIST_MONITOR: {
    method: "DELETE",
    path: "/api/monitors/blacklists/:monitor_id",
  },
  BLACKLIST_REPORTS: {
    method: "GET",
    path: "/api/reports/blacklists/:monitor_id?date=:date",
  },
  NEW_CERTIFICATE_MONITOR: {
    method: "POST",
    path: "/api/monitors/certificates",
  },
  CERTIFICATE_MONITORS: {
    method: "GET",
    path: "/api/monitors/certificates",
  },
  UPDATE_CERTIFICATE_MONITOR: {
    method: "PATCH",
    path: "/api/monitors/certificates/:monitor_id",
  },
  DELETE_CERTIFICATE_MONITOR: {
    method: "DELETE",
    path: "/api/monitors/certificates/:monitor_id",
  },
  CERTIFICATE_REPORTS: {
    method: "GET",
    path: "/api/reports/certificates/:monitor_id?date=:date",
  },
  APIKEY: {
    method: "GET",
    path: "/api/apikey",
  },
  APIKEY_GENERATE: {
    method: "POST",
    path: "/api/apikey",
  },
  RISK_URL_LIST: {
    method: "GET",
    path: "/api/urlscanner",
  },
  RISK_URL_USAGE: {
    method: "GET",
    path: "/api/urlscanner/usage",
  },
  RISK_URL: {
    method: "POST",
    path: "/api/urlscanner",
  },
  RISK_URL_STRIPE: {
    method: "POST",
    path: "/api/stripe/urlscanner",
  },
  STRIPE_USER: {
    method: "GET",
    path: "/api/stripe/user",
  }
};

const API_ON_ERR = {
  IGNORE: 1,
  TOAST: 2,
  THROW: 3,
};

const SETTINGS = {
  apiKey: "",
  apiUrl: process.env.VUE_APP_DRUPAL_URL,
  siteUrl: "",
};

const callAPI = async function (
  route,
  params = {},
  data = {}
) {
  const { method, path } = route;
  const url = SETTINGS.apiUrl + bindQueryParams(path, params);
  const headers = {};
  const csrfToken = localStorage.getItem("csrf_token");

  headers["content-type"] = "application/json";
  headers["Accept"] = "*/*";
  if (csrfToken) headers["X-CSRF-Token"] = csrfToken;

  try {
    const res = await client({
      method,
      url,
      headers,
      data,
    });
    return res;
  } catch (err) {
    if (err.response && err.message) {
      return { 'status': err.response.status, 'message': err.message }
    }

  }
};

function bindQueryParams(url, params) {
  for (const key of Object.keys(params)) {
    url = url.replace(`:${key}`, encodeURIComponent(params[key]));
  }

  return url;
}

export { callAPI, DRUPAL_API_ROUTE, API_ON_ERR, SETTINGS };
